import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { formatVND } from '../../lib/format';

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    Promise.all([
      supabase.from('orders').select('id, total, payment_status, status, created_at').order('created_at', { ascending: false }).limit(200),
      supabase.from('products').select('id, name, stock_quantity').lt('stock_quantity', 20),
      supabase.from('checklist_templates').select('id').eq('active', true),
      supabase.from('checklist_entries').select('id, done').eq('entry_date', today),
      supabase.from('sale_push').select('id').eq('status', 'active'),
    ]).then(([orders, lowStock, tpl, entries, push]) => {
      const list = orders.data || [];
      const todayOrders = list.filter((o) => (o.created_at || '').slice(0, 10) === today);
      setStats({
        todayCount: todayOrders.length,
        todayRevenue: todayOrders.reduce((s, o) => s + Number(o.total || 0), 0),
        pendingPay: list.filter((o) => o.payment_status === 'pending' && o.status !== 'cancelled').length,
        pendingShip: list.filter((o) => ['pending', 'confirmed', 'delivering'].includes(o.status)).length,
        lowStock: lowStock.data || [],
        checklistDone: (entries.data || []).filter((e) => e.done).length,
        checklistTotal: (tpl.data || []).length,
        pushCount: (push.data || []).length,
      });
    });
  }, []);

  if (!stats) return <div className="loading">Đang tải...</div>;

  const tiles = [
    ['Đơn hôm nay', stats.todayCount, '/admin/orders'],
    ['Doanh thu hôm nay', formatVND(stats.todayRevenue), '/admin/orders'],
    ['Chờ xác nhận thanh toán', stats.pendingPay, '/admin/orders'],
    ['Đơn chưa giao xong', stats.pendingShip, '/admin/orders'],
    [`Checklist hôm nay`, `${stats.checklistDone}/${stats.checklistTotal}`, '/admin/checklist'],
    ['Hàng đang cần đẩy sale', stats.pushCount, '/admin/sale-push'],
  ];

  return (
    <div>
      <h2>📊 Tổng quan hôm nay</h2>
      <div className="grid grid-3" style={{ marginBottom: 20 }}>
        {tiles.map(([lbl, num, to]) => (
          <Link key={lbl} to={to} className="card stat-tile" style={{ textDecoration: 'none' }}>
            <div className="num">{num}</div>
            <div className="lbl">{lbl}</div>
          </Link>
        ))}
      </div>

      <h3>📦 Tồn kho thấp (&lt; 20)</h3>
      {stats.lowStock.length === 0 ? (
        <div className="card empty">Không có sản phẩm nào sắp hết hàng.</div>
      ) : (
        <div className="table-wrap">
          <table className="tbl">
            <thead><tr><th>Sản phẩm</th><th>Tồn</th></tr></thead>
            <tbody>
              {stats.lowStock.map((p) => (
                <tr key={p.id}><td>{p.name}</td><td><strong style={{ color: 'var(--red)' }}>{p.stock_quantity}</strong></td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
